import { Box, Popover, Typography, useMediaQuery } from "@mui/material";
import { LocalizationProvider, StaticTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
// import { format } from "date-fns";

export default function ClockArea({
  show,
  setShow,
  date,
  setDate,
  dateEnd,
  setDateEnd,
  detail,
  notRange,
  ...props
}) {
  //   const [value, setValue] = useState();
  const handleClose = () => {
    setShow(null);
  };

  const open = Boolean(show);
  const id = open ? "simple-popover" : undefined;
  const md = useMediaQuery("(max-width:450px)");

  return (
    <Box sx={{ direction: "ltr" }}>
      <Popover
        id={id}
        open={open}
        anchorEl={show}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: detail ? "left" : "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: detail ? "left" : "right",
        }}
        sx={{
          "& .MuiPaper-root ": {
            direction: "ltr !important",
          },
        }}
        {...props}
      >
        <Box display="flex" flexDirection={md ? "column" : "row"}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticTimePicker
              onChange={(e) => {
                const formattedTime = `${String(e.$H).padStart(
                  2,
                  "0",
                )}:${String(e.$m).padStart(2, "0")}`;
                setDate(formattedTime);
              }}
              defaultValue={dayjs(`2022-04-17T${date ?? "00:00"}`)}
              displayStaticWrapperAs="desktop"
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticTimePicker
              onChange={(e) => {
                const formattedTime = `${String(e.$H).padStart(
                  2,
                  "0",
                )}:${String(e.$m).padStart(2, "0")}`;
                setDateEnd(formattedTime);
              }}
              defaultValue={dayjs(`2022-04-17T${dateEnd ?? "00:00"}`)}
              displayStaticWrapperAs="desktop"
            />
          </LocalizationProvider>
        </Box>
        <Box>
          <Typography
            textAlign={"center"}
            p="10px 20px"
            sx={{ cursor: "pointer" }}
            onClick={handleClose}
          >
            تایید
          </Typography>
        </Box>
      </Popover>
    </Box>
  );
}
